import { FormLabel, styled as styledMui, Typography } from '@mui/material';
import { styled } from 'styled-components';

import { visuallyHidden } from '../../../styles/common';

export const AttachmentLabel = styledMui(FormLabel)`
  display: flex;
  padding: var(--spacing-tiny);
`;

export const Section = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  padding: var(--spacing-huge);
`;

export const SectionInline = styled.section`
  align-items: center;
  border-bottom: var(--border-dark);
  display: flex;
  flex-direction: row;
  gap: var(--spacing-small);
  padding-bottom: var(--spacing-medium);
  padding-left: var(--spacing-small);
`;

export const Title = styledMui(Typography)`
  font-weight: var(--font-semibold);
`;

export const FileUploadInput = styled.input`
  ${visuallyHidden}
`;
